import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {NaviosModel} from "./navios.model";
import {NaviosService} from './navios.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";


@Component({
  selector: 'app-navios-form',
  templateUrl: './navios-form.component.html'
})
export class NaviosFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  navio: NaviosModel = new NaviosModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  id_navio: string = '';
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private naviosService: NaviosService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]]
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_navio'];

      this.id_navio = id;

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarNavio');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarNavio') : this.func.traduzir('front.cadastrarNovoNavio');
      }

      if (!id) {
        return;
      }

      this.naviosService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.title = this.func.traduzir('front.editarNavio')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarNavio') + ': ' + json.Payload[0].nome;
            }
            this.navio = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,
      values = this.form.value;

    if (values.id) {
      result = this.naviosService.editar(values, values.id);
    } else {
      result = this.naviosService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'navios']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/navios/navios-form.component.ts